var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87 82",
    xmlSpace: "preserve",
    height: 83,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .st0{fill:#FFFFFF;}\r\n        .st1{fill:#FFFFFF;stroke:#000000;strokeWidth:1.5;strokeLinecap:round;}\r\n        .st2{fill:none;stroke:#000000;strokeWidth:1.4;strokeLinecap:round;}\r\n        .st3{fill:#0D1C3D;stroke:#000000;}\r\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "4.7,52.7 30.4,69.8 37,55.6 10.7,46.1 4.8,52.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.2,64.5c-9,0-24.3,5-23.5-1c-0.1-1.3,1.1-4,6.4-5.7c2-0.7,4-1.4,5.8-2.5c5.2-3.3,11.7-7.1,16.3-6.3   c5.2,0.9,20.1,0.6,28.1-2c0.7-0.2,1.4,0.3,1.4,1c-0.1,6.4-0.6,15.4-0.9,20.1c0,0.5-0.5,0.9-1,0.9h-2.4c-2.1,0-4.2,0.5-6.1,1.4   c-7.8,3.7-19,8.4-26.6,10.3c-5.3,1.3-10.5-1.4-15.3-4C20.6,69.8-2.2,57,1.7,51c0.8-3.6,15.5,8,26.1,11.5 M3.2,50   c-0.7-2.3-0.5-6.3,5.5-3.5c7.5,3.5,15.7,13.6,21.7,13 M9.7,46.5c0-1.7,1.6-4.3,8,0.5c8,6,19,8.7,21,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.7,55c0,3-0.1,9.2-0.5,10 M77.7,61.5c0,1.3-0.1,4.1-0.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,43l1.7-10.4c-5-0.7-6.4-6.3-6.5-9.1c0-2.1-0.1-7.9,0-14.1c0.1-6.2,5.5-8.1,8.2-8.4h29.9   c4,0,6.2,2.4,7.2,4.6c0.4,0.9,0.6,1.7,0.7,2.4v16c0,0,0,0.1,0,0.1c-0.1,8.3-12.1,8.5-20.5,8.5h-12l-3,3.6L36.1,43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 11.5,
    className: "st3",
    width: 33,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.7,
    y: 19.5,
    className: "st3",
    width: 21,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,54.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLaptop);
export default __webpack_public_path__ + "static/media/whyLaptop.8622f8d1020f3a767471c0b8d984335e.svg";
export { ForwardRef as ReactComponent };